import { StoryblokBlockComponent } from "../../lib/storyblok/types/StoryblokComponent";
import { CarouselBlock } from "../../lib/storyblok/types/blocks/CarouselBlock";
import CarouselUi from "../../ui/Carousel/ImageCarousel";
import Button from "../../ui/Button";
import { useLinks } from "../../lib/storyblok/useLinks";
import { useContentStyle } from "../../hooks/useStyle";

const ImageCarousel: StoryblokBlockComponent<CarouselBlock> = ({
  title,
  description,
  buttons,
  items,
  style,
  spacing,
  outerSpacing,
  carouselWidth,
  effect,
  overlayVisibility,
}) => {
  const isInverted = useContentStyle(style);
  const resolveLink = useLinks();

  const buttonCollection = buttons?.map((button) => (
    <Button
      key={button._uid}
      variant={button.buttonType || "default"}
      href={button.buttonLink ? resolveLink(button.buttonLink) : ""}
    >
      {button.buttonText}
    </Button>
  ));

  return (
    <CarouselUi
      title={title}
      description={description}
      buttons={buttonCollection}
      items={items}
      carouselWidth={carouselWidth}
      style={style}
      spacing={spacing}
      outerSpacing={outerSpacing}
      effect={effect}
      overlayVisibility={overlayVisibility}
      inverted={isInverted}
    />
  );
};

export default ImageCarousel;
